import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Expense, UpdateExpenseDto } from '@/types/settings';

export function useUpdateExpense(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<Expense, { id: string; dto: UpdateExpenseDto }>({
    mutationFn: ({ id, dto }) =>
      apiPatch<Expense, UpdateExpenseDto>(operationsClient, expenseEndpoints.update(id), dto),
    onSuccess: (_expense, variables) => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.detail(variables.id) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      toast.success('Expense updated');
    },
  });
}
